<simple-card class="ClaimItemsInformationReview__SimpleCard">
  <div
    title
    class="ClaimItemsInformationReview__Title"
    data-test-id="ClaimItemsInformationReviewTitle"
  >
    <h6 class="t-bold">{{ title }}</h6>
    @if (isEditable) {
      <icon
        name="edit"
        [config]="{ type: 'link' }"
        data-test-id="ClaimItemsInformationReviewIcon"
        (click)="editIconClicked()"
      ></icon>
    }
  </div>
  @for (infoConfig of claimItemsInfoConfig; track infoConfig) {
    <model-attribute
      class="ClaimItemsInformationReview__ModalAttributes"
      [config]="infoConfig"
      [context]="context"
      direction="row"
    >
    </model-attribute>
  }
</simple-card>
